/** @fileoverview Loads a tenant's connected SuccessFactors and SAP HCM systems. */

import { useEffect, useState } from 'react';
import { listConnectedSystems } from '../services/systemsApi';
import type { ConnectedSystem } from '../services/systemsApi';

export default function useConnectedSystems(tenantId: string) {
  const [result, setResult] = useState<{ tenantId: string; systems: ConnectedSystem[] }>({
    tenantId: '',
    systems: [],
  });

  useEffect(() => {
    const controller = new AbortController();
    listConnectedSystems(tenantId, controller.signal)
      .then((systems) => setResult({ tenantId, systems }))
      .catch(() => {
        if (!controller.signal.aborted) setResult({ tenantId, systems: [] });
      });
    return () => controller.abort();
  }, [tenantId]);

  return result.tenantId === tenantId ? result.systems : [];
}
